import { type Vector3 } from '@canvas/vector-types';

import { type AnyElement, type AnyElementData } from '../all-element-types';
import {
  type Element,
  type ElementDataWithContent,
  elementType,
  type ElementType,
} from '../element';

import { type PathOffsetPosition } from './path';

export interface PathLabelElementPasteData extends PathLabelElementData {
  sourcePathIndex: number;
}

export interface PathLabelElementData extends ElementDataWithContent<ElementType> {
  text: string;
  color: Vector3;
  sourcePathId: string;
  fontScale?: number;
  proportion: number;
  pathOffsetPosition?: PathOffsetPosition;
  /**
   * ⚠️ If we ever add basisSize and basisPosition here, ensure that the corresponding type-guards
   * are updated accordingly in @link packages/sizing-feature-flags/src/sizing-feature-flags.ts
   */
}

export interface PathLabelElement extends PathLabelElementData, Element<ElementType> {}

export function isPathLabel(
  element: AnyElement | undefined,
): element is PathLabelElement {
  return element !== undefined && element.type === pathLabelElementType;
}
export function isPathLabelData(
  element: AnyElementData | undefined,
): element is PathLabelElementData {
  return !!element && element.type === pathLabelElementType;
}
export const pathLabelElementType = elementType('pathLabel');
